var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A8B2B9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.545 5.753C7.524 3.473 9.24 1.64 11.376 1.66c2.137.02 3.887 1.885 3.909 4.164l.14 14.86c.013 1.368-1.016 2.467-2.299 2.455-1.282-.012-2.332-1.13-2.345-2.498l-.109-11.558c-.004-.456.339-.822.766-.818.428.004.778.377.782.833l.109 11.557c.004.456.354.83.782.833.427.004.77-.362.766-.818l-.14-14.86c-.008-.885-.459-1.707-1.181-2.156-.723-.45-1.608-.457-2.322-.022-.714.436-1.15 1.25-1.14 2.134l.14 14.86c.02 2.28 1.77 4.144 3.908 4.164 2.137.02 3.852-1.811 3.83-4.09l-.108-11.559c-.004-.456.339-.822.766-.818.427.004.777.377.782.833l.109 11.558c.03 3.191-2.371 5.756-5.364 5.728-2.992-.029-5.442-2.639-5.472-5.83l-.14-14.86z",
    transform: "translate(-849 -270) translate(276 140) translate(573 130) translate(.467 .438) rotate(45 13.033 14.052)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachment);
export default __webpack_public_path__ + "static/media/icon-attachment.bd30306a8695ac260eee625c7feb8dee.svg";
export { ForwardRef as ReactComponent };